import { library, icon } from '@fortawesome/fontawesome-svg-core';
import { faFolderOpen, faBars, faPlay } from '@fortawesome/free-solid-svg-icons';

// Add the imported icons to the library
library.add(faFolderOpen, faBars, faPlay);

const folderOpen = icon({ prefix: 'fas', iconName: 'folder-open' });
const bars = icon({ prefix: 'fas', iconName: 'bars' });
const play = icon({ prefix: 'fas', iconName: 'play' });

import 'bootstrap';
import 'bootstrap5-toggle';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap5-toggle/css/bootstrap5-toggle.min.css';

import '../../src/styles/style.css';
import '../../src/styles/theme.css';
import '../../src/styles/maps.css';
import '../../src/styles/slider.css';

import { renderHeader } from '../components/project-header';
import { renderFooter } from '../components/footer';

import '../modules/maps';

/*import interfaces*/
import { Aeroval } from '../types/global';
declare var aeroval: Aeroval;

import globeLoading from '../../src/assets/images/hp-globe.webm';

// Render header
const headerContainer = document.getElementById('header');
if (headerContainer instanceof HTMLDivElement) {
    headerContainer.appendChild(renderHeader());
}

// index
document.querySelector<HTMLDivElement>('#app')!.innerHTML = `
<div class="container w-100" id="nomenu" style="display: none;">
            ${folderOpen.html}
            This project is empty
        </div>
        <div class="main-content">
            <div id="main-row" class="row h-100">
                <div class="col-xxl-2 col-lg-3 col-12">
                    <div id="expContainer" class="left-box">
                        <div id="menu-experiment"></div>
                        <div id="info-experiment">
                            <div id="description-experiment"></div>
                        </div>
                    </div>
                    <div id="data-policy" class='left-box'></div>
                </div>
                <div class="col-xxl-8 col-lg-9 col-12">
                <div id="menu"></div>
                    <div id="below-menu">
                        <div id="first_row" class="row w-100 d-flex" style="margin-top: 10px;">
                            <div id="collapseMenu" class="dropdown" style=" z-index: 12; width: 30px; height: 30px;">
                                <button type="button" class="btn btn-xs btn-light" id="dropdownMapMenu" data-bs-toggle="dropdown" data-bs-auto-close="outside" data-bs-offset="0,0" aria-expanded="false">
                                    ${bars.html}
                                </button>
                                <div id="mapMenu" class="dropdown-menu dropdown-menu-left bg-light bg-opacity-75" aria-labelledby="dropdownMapMenu"></div>
                                <!--button type="button" class="btn btn-xs btn-light mt-2" id="playMap">
                                </button-->
                            </div>

                            <div id="mapMenu" class="dropdown-menu dropdown-menu-left bg-light bg-opacity-75" aria-labelledby="dropdownMapMenu"></div>
                            <div id='tabLegend' style="width: 60px"></div>
                            <div id="mapContent" style="width: calc(100% - 60px);">
                                <div id="map1" class="d-flex">
                                    <div id="waiter" class="align-self-center justify-content-center mapMessage" style="display: none; align-items: center">
                                        <video src="${globeLoading}" width="40px" autoplay loop muted playsinline></video>
                                        <span class="ms-2">... loading</span>
                                    </div>
                                    <div class="map _2D w-100" id='mod1-2D'></div>
                                    <div class="map _3D w-100" id='mod1-3D' class='leaflet-container' style='display: none;'></div>
                                    <div id="mapMessage-mod1" class="align-self-center justify-content-center mapMessage" style="display: none;">
                                    </div>
                                    <div id="pixInfo1" class="align-self-end"></div>
                                </div>
                                <div id="map2" class="d-flex" style="display: none !important">
                                    <div class="map _2D w-100" id='mod2-2D'></div>
                                    <div id="mapMessage-mod2" class="align-self-center align-content-center mapMessage" style="display: none;">
                                    </div>
                                    <div id="pixInfo2" class="align-self-end"></div>
                                </div>
                            </div>
                        </div>
                        <!--button id='globeRotationButton' type='button' class='btn btn-sm btn-light' style='margin-top: -50px; margin-left: 10px; display: none'>
                            <span id='faPlay'>${play.html}</span>
                        </button-->
                        <div id="second_row" class="row w-100" style="width: 100%; margin: 0; padding: 0;">
                            <!--div class="col-md-3 col-12 dynamic-chart" style="padding: 0">
                                <div id='map-scat' style="visibility: hidden;"></div>
                            </div-->
                            <div class="col-lg-12 col-md-12 dynamic-chart" style="padding: 0">
                                <div id="map-ts"></div>
                                <input class="slider" id="m_slider" style="visibility: hidden;" type="range" min="0" max="11" value="0" width="100%" />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
`;

// Render header
const footerContainer = document.getElementById('footer');
if (footerContainer instanceof HTMLDivElement) {
    footerContainer.appendChild(renderFooter());
}

document.addEventListener('DOMContentLoaded', () => {
    // initialize bootstrap toggles
    document.querySelectorAll("[data-toggle='toggle']").forEach((element) => {
        (element as any).bootstrapToggle({
            onstyle: aeroval.settings.theme,
            offstyle: aeroval.settings.theme,
            size: 'mini',
        });
    });
});
